import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UnknownAction } from "redux";
import { AppState } from "../../store/types";
import {
  clearComparisonFilters,
  clearDetailFilters,
  updateComparisonFilters,
  updateComparisonSort,
  updateCoverageStatus,
  updateDetailFilters,
  updateDetailSort,
  updateSharedFilters,
} from "./actions";
import { PayerLandscapeDispatch, PayerLandscapeState } from "./types";

export const usePayerLandscapeState = (): PayerLandscapeState =>
  useSelector(({ payerLandscape }: AppState) => {
    return payerLandscape;
  });

export const usePayerLandscapeDispatch = (): PayerLandscapeDispatch => {
  const dispatch = useDispatch();
  // typescript-fsa Action<T> lacks the index signature required by Redux 5's UnknownAction;
  // as unknown as UnknownAction is an intentional compatibility shim — migrate to RTK createAction to remove it.
  return useMemo(
    (): PayerLandscapeDispatch => ({
      updateSharedFilters: (filters) => dispatch(updateSharedFilters(filters) as unknown as UnknownAction),
      updateDetailFilters: (filters) => dispatch(updateDetailFilters(filters) as unknown as UnknownAction),
      clearDetailFilters: () => dispatch(clearDetailFilters() as unknown as UnknownAction),
      updateDetailSort: (sort) => dispatch(updateDetailSort(sort) as unknown as UnknownAction),
      updateComparisonFilters: (filters) => dispatch(updateComparisonFilters(filters) as unknown as UnknownAction),
      clearComparisonFilters: () => dispatch(clearComparisonFilters() as unknown as UnknownAction),
      updateComparisonSort: (sort) => dispatch(updateComparisonSort(sort) as unknown as UnknownAction),
      updateCoverageStatus: (coverageStatus) =>
        dispatch(updateCoverageStatus(coverageStatus) as unknown as UnknownAction),
    }),
    [dispatch],
  );
};
